import { MatPaginatorIntl } from '@angular/material/paginator';
import { LanguageProvider } from './shared/language-provider';

const macedonianRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length == 0 || pageSize == 0) { return `0 ${length}`; }
  
  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} ${length}`;
}

export function getMacedonianPaginatorIntl(provider: LanguageProvider) {
  const paginatorIntl = new MatPaginatorIntl();
  
    paginatorIntl.itemsPerPageLabel = provider.translate('ITEMS_PER_PAGE');
    paginatorIntl.nextPageLabel = provider.translate('NEXT_PAGE');
    paginatorIntl.previousPageLabel = provider.translate('PREVIOUS_PAGE');
    paginatorIntl.firstPageLabel = provider.translate('FIRST_PAGE');
    paginatorIntl.lastPageLabel = provider.translate('LAST_PAGE');
    
    paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        const rangeText = provider.translate('OF');
        return `${page * pageSize + 1} - ${Math.min((page + 1) * pageSize, length)} ${rangeText} ${length}`;
    };

    return paginatorIntl;
}

